import * as React from 'react'
import { FC, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ContentBack } from './ContentBack/ContentBack'
import { ContentFront } from './ContentFront'
import { WidgetWrapper } from '../../Widget/WidgetWrapper'
import {
  flipCard,
  selectManageAgreements,
} from '@user/store/dashboard/widgets/manageAgreements/manageAgreements'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

export const ManageAgreements: FC = () => {
  const dispatch = useAppDispatch()
  const { showFront } = useSelector(selectManageAgreements)

  const handleFlipCard = useCallback(() => {
    dispatch(flipCard())
  }, [dispatch])

  return (
    <WidgetWrapper
      testIdPrefix="manage-agreements-widget"
      contentFront={<ContentFront />}
      contentBack={<ContentBack />}
      title="Manage Agreements"
      settingsAction={handleFlipCard}
      showFront={showFront}
    />
  )
}

ManageAgreements.displayName = 'ManageAgreements'
